import React from 'react'
import PropTypes from 'prop-types'
import Icon from '@material-ui/core/Icon';

const MaterialIcon = function({icon}) {
    return <Icon>{icon}</Icon>
}

MaterialIcon.propTypes = {
    icon: PropTypes.string.isRequired
}

export default MaterialIcon
